import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';
import i18n from '../../../../i18next';
import { GridLoader } from 'react-spinners';
import { pushDataToGoogleTagManager } from '../../../../utils/AnalyticsUtils';
import { isMobile, isTablet } from "mobile-device-detect";

import {
    loadPaymentTypes,
    selectPaymentType,
    getCustomerPaymentCards,
    selectCustomerPaymentCard,
    clearPaymentCard,
    saveGeneralInstructions,
    clearWizardData,
    getSelectedProductForEdit,
    editProduct,
    closeStartOrderScreen,
    openChangeOrderTimeScreen,
    clearTemporaryOrderTimeData,
    saveNewOrderTime,
    clearState,
    getSelectedProduct,
    stopLoader,
    processingPayment,
    getOldestActiveLoyalty,
    changeAppleGooglePayAvailability,
    getRestaurantPauseStatus,
    voidPurchase,
    resetOldDiscountFlag,
    cancelComoPayment,
    applyGiftCard,
    clearGiftCardsErrorMessage,
    deleteCustomerCard
} from '../../../../actions/index';
import {
    getLoggedInUserFirstName,
    setLastOpenedPagePWA
} from '../../../../utils/CommonUtils';
import { updateCSSVariables } from '../../../../utils/ThemesSelector';
import { getAllUrlParams } from '../../../../utils/CommonUtils';

import ApplicationStep from '../../common/ApplicationStep';
import SendingOrderModal from '../../../../components/order/SendingOrderModal';
import PaymentAdapter from '../../../../components/order/providers/PaymentAdapter';
import CheckoutInformation from './CheckoutInformation';
import CheckoutPaymentInformation from './CheckoutPaymentInformation';
import ShoppingCart from '../../../../components/order/shoppingCart/ShoppingCart';
import ConfirmationModal from '../../../../components/common/ConfirmationModal';
import { ARABIC } from '../../../../utils/Constants';
import SavedCardsModal from '../../../../components/order/SavedCardsModal';
import MenuLoaderContainer from '../../../../components/order/menu/MenuLoaderContainer';

class CheckoutScreenPwa extends Component {
    constructor(props) {
        super(props);

        this.state = {
            generalInstructions: '',
            activeClass: false,
            openConfirmationDialog: false,
            selectedPaymentId: null,
            selectedPaymentCard: {},
            paymentType: '',
            selectedProductWizardOpened: false,
            isChangeTimeScreenOpened: false,
            stateAlreadyCopiedFromProps: false,
            isAppleGooglePayAvailable: false,
            openConfirmationModal: false,
            currentGiftCard: {
                cardId: '',
                amount: 0
            },
            isSavedCardModalOpen: false,
            selectedCardInfo: null,
            openDeleteCardDialog: false,
            selectedCard: ''
        };

        this.changeState = this.changeState.bind(this);
        this.onBackKeyDown = this.onBackKeyDown.bind(this);
        this.selectCard = this.selectCard.bind(this);
        this.goBack = this.goBack.bind(this);
        this.removeGiftCard = this.removeGiftCard.bind(this);
        this.applyGiftCardInformation = this.applyGiftCardInformation.bind(this);
        this.toggleSavedCardsModal = this.toggleSavedCardsModal.bind(this);
        this.deleteSavedCreditCard = this.deleteSavedCreditCard.bind(this);
        this.renderSavedCardModalBody = this.renderSavedCardModalBody.bind(this);
        this.toggleDeleteCardDialog = this.toggleDeleteCardDialog.bind(this);
        this.confirmDeleteCard = this.confirmDeleteCard.bind(this);
    }

    componentWillMount() {
        window.scrollTo(0, 0);

        this.props.getRestaurantPauseStatus();

        this.props.loadPaymentTypes();
        // Ryft (provider id 10) renders the customer's saved cards inside its own form,
        // so our own card-listing logic is skipped for it.
        const isRyft = this.props.paymentProvider.providerType && this.props.paymentProvider.providerType.id === 10;
        if (!isRyft) {
            this.props.getCustomerPaymentCards();
        }

        // Listen for route change and stop the loader from checkout
        this.props.history.listen((location, action) => {
            this.props.stopLoader();
        });
    }

    componentDidMount() {
        this.applyTheme();
        this.copyStateFromProps();

        const totalWithGiftCardIsZero = this.props.giftCards.giftCards ? this.props.giftCards.giftCards.total === 0 : false;
        const isAppliedGiftCards = this.props.giftCards.giftCards ? this.props.giftCards.giftCards.appliedGiftCards && this.props.giftCards.giftCards.appliedGiftCards.length > 0 : false;

        pushDataToGoogleTagManager('event', 'checkout', this.props.pwaAppRunning, this.props.shoppingCart, this.props.restaurantProducts, this.props.restaurantCategories, this.props.selectedRestaurant.currency);
        const url = window.location.href;
        const queryParams = getAllUrlParams(url);

        if (this.props.customer.id == -1 && this.props.menuPreviewMode == false) {
            window.location.reload();
        }

        if (Object.keys(queryParams).length !== 0) {

            const data = {
                paymentCardDTO: null,
                paymentToken: queryParams.source
            };

            if (window.performance) { // TODO WHAT DAFUQ IS THIS????
                if (performance.navigation.type == 1) {
                    this.props.placeOrder(false, true, data);
                }
            }
        }

        setLastOpenedPagePWA(this.props.openChangeOrderTimeScreen);

        document.addEventListener("backbutton", this.onBackKeyDown, false);

        // Gets an active loyalty code whenever user is logged in
        const { customer } = this.props;

        const appliedPromotions = this.props.shoppingCart ? this.props.shoppingCart.appliedPromotions : null;
        let isAppliedPromotionWithPromoCode = false;
        if(appliedPromotions && appliedPromotions.length) {
            appliedPromotions.map((promotion, index) => {
                if(promotion.promoCode) {
                    isAppliedPromotionWithPromoCode = true;
                }
            })
        }

        if (customer.token && !this.props.storeLocalStorage.codeManuallySet && customer.autoApplyLoyalty && !isAppliedPromotionWithPromoCode) {
            this.props.getOldestActiveLoyalty();
        }

        // This invocation handles selection on page refresh, if card has already been selected e.i.
        this.selectCard();

        if ((this.props.shoppingCart.discount > 0 && this.props.shoppingCart.total === 0) || (!totalWithGiftCardIsZero && isAppliedGiftCards)) { // if total after discount is 0 or less
            this.props.selectPaymentType({ id: 2, value: 'Cash' });
            this.clearPaymentCard();
        }

        if (this.props.storeLocalStorage.isAppleGooglePayAvailable && (!totalWithGiftCardIsZero && !isAppliedGiftCards))  {
            this.setState({
                ...this.state,
                isAppleGooglePayAvailable: this.props.storeLocalStorage.isAppleGooglePayAvailable
            })
        }

        const isAppleGooglePayAvailable = this.props.storeLocalStorage.isAppleGooglePayAvailable;

        if (isMobile && isAppleGooglePayAvailable && this.props.payment.selectedPaymentType) {
            this.styleActiveElements(this.props.payment.selectedPaymentType);
        }

        if (this.props.giftCards.errorMessage || !this.state.currentGiftCard.cardId) {
            this.props.clearGiftCardsErrorMessage();
        }
    }

    componentWillUnmount() {
        const totalWithGiftCardIsZero = this.props.giftCards.giftCards ? this.props.giftCards.giftCards.total === 0 : false;
        const isAppliedGiftCards = this.props.giftCards.giftCards ? this.props.giftCards.giftCards.appliedGiftCards && this.props.giftCards.giftCards.appliedGiftCards.length > 0 : false;
        // console.log('CheckoutScreenPwa WillUnmount');
        const isLoggedInPromotionPartner = this.props.promotionPartners.isUserLoggedInPartner;
        const isComo = this.props.promotionPartners.promotionPartner && this.props.promotionPartners.promotionPartner.id === 2;
        document.removeEventListener("backbutton", this.onBackKeyDown, false);
        // if (this.props.history.action === 'POP') {
        // window.onpopstate = null;
        // }

        if (!totalWithGiftCardIsZero && !isAppliedGiftCards){
            this.props.changeAppleGooglePayAvailability(null);
        } 

        const { brandId } = this.props;
        const isProfileScreen = window.location.href.includes('profile');
        const isTipScreen = window.location.href.includes(`/brand/${brandId}/order/tip`);

        if (isComo && !isProfileScreen && isLoggedInPromotionPartner && !isTipScreen) {
            const onSuccess = () => {
                this.props.voidPurchase(() => this.props.resetOldDiscountFlag());
                this.props.resetPromoCodeField();
            };

            this.props.cancelComoPayment(onSuccess);
        }

        if (this.state.isSavedCardModalOpen) {
            this.setState({
                isSavedCardModalOpen: false
            })
        }
    }

    onBackKeyDown() {

        const { brandId } = this.props;

        const isLoggedInPromotionPartner = this.props.promotionPartners.isUserLoggedInPartner;
        const isShoppingCartEmpty = this.props.shoppingCart.orderProducts.length > 0 ? false : true;

        if (isLoggedInPromotionPartner) {
            this.toggleConfirmationModal();
        } else if (!isShoppingCartEmpty) {
            this.goBack()
        }
    }

    componentDidUpdate(prevProps) {
        this.applyTheme(prevProps);
        const isCashExist = this.props.payment.paymentTypes.some(e => e.id === 2);
        const isLoggedInPromotionPartner = this.props.promotionPartners.isUserLoggedInPartner;
        const { brandId } = this.props;

        this.setPaymentType(isCashExist, prevProps);

        // if (this.props.giftCards.giftCards !== prevProps.giftCards.giftCards) {
        //     this.setState({
        //         ...this.state,
        //         // appliedGiftCards: this.props.giftCards.giftCards.appliedGiftCards,
        //         currentGiftCard: {
        //             cardId: '',
        //             amount: 0
        //         }
        //     });
        // }

        // window.history.pushState(null, null, window.location.href);
        // window.onpopstate = (event) => {
        //     this.onBackKeyDown();
        // }
    }

    copyStateFromProps() {

        if (this.props.payment !== undefined && this.props.payment !== null &&
            this.props.payment.selectedPaymentType !== undefined && this.props.payment.selectedPaymentType !== null
            && !this.state.stateAlreadyCopiedFromProps) {

            const isAppleGooglePayAvailable = this.props.storeLocalStorage.isAppleGooglePayAvailable;
            const totalWithGiftCardIsZero = this.props.giftCards.giftCards ? this.props.giftCards.giftCards.total === 0 : false;
            const isAppliedGiftCards = this.props.giftCards.giftCards ? this.props.giftCards.giftCards.appliedGiftCards && this.props.giftCards.giftCards.appliedGiftCards.length > 0 : false;

            if ((this.props.shoppingCart.discount > 0 && this.props.shoppingCart.total === 0) || (totalWithGiftCardIsZero && isAppliedGiftCards)) { // if total after discount is 0 or less
                this.setState({
                    ...this.state,
                    selectedPaymentId: 2,
                    paymentType: 'Cash',
                    stateAlreadyCopiedFromProps: true
                });
            } else {
                this.setState({
                    ...this.state,
                    selectedPaymentId: !isAppleGooglePayAvailable ? this.props.payment.selectedPaymentType.id : 3,
                    paymentType: !isAppleGooglePayAvailable ? (this.props.payment.selectedPaymentType.id == 1) ? 'Credit card' : 'Cash' : 'Credit card',
                    stateAlreadyCopiedFromProps: true
                });
            }

            if (isMobile && isAppleGooglePayAvailable && this.props.payment.selectedPaymentType) {
                this.styleActiveElements(this.props.payment.selectedPaymentType);
            }
        }
    }


    setPaymentType(isCashExist, prevProps) {
        const { shoppingCart, shoppingCartProducts, payment, giftCards } = this.props;
        const { minimumOrderAmount } = this.props.selectedRestaurant;
        let currentMinimumOrderAmount = shoppingCart.appliedPromotions.length ? 1 : minimumOrderAmount;
        const isPrevTotalDifFromCurrTotal = prevProps.shoppingCart.total !== shoppingCart.total;
        const isCurrDiscountBiggerThanZero = shoppingCart.discount > 0;
        const isCurrTotalBiggerThanZeroAndLessThanCurrMinOrderAmount = shoppingCart.total > 0 && shoppingCart.total < currentMinimumOrderAmount;
        const isProductLengthDifferent = prevProps.shoppingCartProducts.length !== shoppingCartProducts.length;
        const noProductsInCart = shoppingCartProducts.length === 0;
        const zeroTotalZeroDiscount = shoppingCart.total === 0 && shoppingCart.discount === 0;
        const totalBiggerOrEqualToCurrMinOrderAmount = shoppingCart.total >= currentMinimumOrderAmount;
        let noneOfTheAboveCases = true;
        const giftCardsTotal = giftCards.giftCards ? giftCards.giftCards.total : null;
        const prevPropsGiftCardsTotal = prevProps.giftCards.giftCards ? prevProps.giftCards.giftCards.total : null;
        const isPrevTotalFromGiftCardsDifFromCurr = prevPropsGiftCardsTotal !== giftCardsTotal;
        const isAppliedGiftCards = this.props.giftCards.giftCards ? this.props.giftCards.giftCards.appliedGiftCards && this.props.giftCards.giftCards.appliedGiftCards.length > 0 : false;
        const totalWithGiftCardIsZero = this.props.giftCards.giftCards ? this.props.giftCards.giftCards.total === 0 : false;

        if ((isPrevTotalDifFromCurrTotal && shoppingCart.total === 0 && isCurrDiscountBiggerThanZero)
            || (isPrevTotalDifFromCurrTotal && zeroTotalZeroDiscount) || (isPrevTotalFromGiftCardsDifFromCurr && giftCardsTotal === 0 && isAppliedGiftCards)) {

            noneOfTheAboveCases = false;
            this.setState({
                selectedPaymentId: 2,
                paymentType: 'Cash'
            }, this.props.selectPaymentType({ id: 2, value: 'Cash' }))
        }

        if ((isPrevTotalDifFromCurrTotal && isCurrTotalBiggerThanZeroAndLessThanCurrMinOrderAmount && isCurrDiscountBiggerThanZero && !(totalWithGiftCardIsZero && isAppliedGiftCards))
            || (isPrevTotalDifFromCurrTotal && totalBiggerOrEqualToCurrMinOrderAmount && isCurrDiscountBiggerThanZero && this.state.selectedPaymentId == 2 && !isCashExist && !(totalWithGiftCardIsZero && isAppliedGiftCards))
            || (isProductLengthDifferent && noProductsInCart && zeroTotalZeroDiscount)
            || (isPrevTotalDifFromCurrTotal && prevProps.shoppingCart.total === 0 && totalBiggerOrEqualToCurrMinOrderAmount)) {

            noneOfTheAboveCases = false;
            this.setState({
                selectedPaymentId: null,
                paymentType: null
            }, this.props.selectPaymentType({ id: null, value: 'Cash' }))
        }

        if (noneOfTheAboveCases && !payment.selectedPaymentType.id && !isCurrTotalBiggerThanZeroAndLessThanCurrMinOrderAmount
            || (noneOfTheAboveCases && (prevProps.giftCards.giftCards !== giftCards.giftCards && (!totalWithGiftCardIsZero && !isAppliedGiftCards)))) {

            let hasCardPaymentOption = false;
            for (const paymentType of payment.paymentTypes) {
                if (paymentType.id === 1) {
                    hasCardPaymentOption = true;
                }
            }

            if (this.state.isAppleGooglePayAvailable) {
                this.setState({
                    ...this.state,
                    selectedPaymentId: 3,
                    paymentType: 'Credit card'
                });

                this.props.selectPaymentType({ id: 3, value: 'Credit card' });
            } else if (hasCardPaymentOption) {
                this.setState({
                    ...this.state,
                    selectedPaymentId: 1,
                    paymentType: 'Credit card'
                });

                this.props.selectPaymentType({ id: 1, value: 'Credit card' });
            } else if (payment.paymentTypes.length === 1) {

                this.setState({
                    ...this.state,
                    selectedPaymentId: payment.paymentTypes[0].id,
                    paymentType: payment.paymentTypes[0].value
                });

                this.props.selectPaymentType(payment.paymentTypes[0]);
            }
        }
    }

    goBack() {
        const { brandId } = this.props;
        this.props.history.push(`/brand/${brandId}/order/menu`);
    }

    toggleConfirmationModal() {
        this.setState({ ...this.state, openConfirmationModal: !this.state.openConfirmationModal });
    }

    toggleDeleteCardDialog(selectedCard) {
        this.setState({
            openDeleteCardDialog: !this.state.openDeleteCardDialog,
            selectedCard: selectedCard
        });
    }

    confirmDeleteCard() {
        const paymentCardId = this.state.selectedCard.paymentCardId;

        this.props.deleteCustomerCard(paymentCardId, () => {
            this.clearSelectedCardState();
        });
    }

    clearSelectedCardState() {
        this.setState({
            selectedCard: ''
        })
    }

    changeState({ target }) {
        if (target.name == 'generalInstructions') {
            this.setState({
                [target.name]: target.value
            }, this.props.saveGeneralInstructions(target.value));
        } else if (target.name == 'giftCardNumber') {
            this.setState({
                currentGiftCard: {
                    ...this.state.currentGiftCard,
                    cardId: target.value
                }
            });
            if (this.props.giftCards.errorMessage) {
                this.props.clearGiftCardsErrorMessage();
            }
        } else {
            this.setState({
                selectedPaymentId: target.id,
                paymentType: target.value
            }, this.selectPayment(target.id));
        }
    }

    changeNotes(value) {
        this.setState({
            ...this.state,
            generalInstructions: value
        }, () => {
            this.props.saveGeneralInstructions(value);
        });
    }

    changePaymentStateMobile = ({ currentTarget }) => {
        const paymentType = currentTarget.id == 2 ? 'Cash' : 'Card';

        this.setState({
            selectedPaymentId: currentTarget.id,
            paymentType: paymentType
        }, this.selectPayment(currentTarget.id))

        this.styleActiveElements(currentTarget);
    }

    styleActiveElements = (target) => {
        const targetId = Number(target.id);
        let activeTick = (target.id == 3) ? document.getElementById("tick_3") : document.getElementById("tick_" + target.id);

        if (activeTick !== null) {
            activeTick.classList.remove("paymentTypeTickDisable");
            activeTick.classList.add("paymentTypeTick");
        }

        if (targetId !== 3) {
            let unActiveTick = document.getElementById("tick_3");

            if (unActiveTick !== null && unActiveTick.classList.value.includes("paymentTypeTick")) {
                unActiveTick.classList.remove("paymentTypeTick");
                unActiveTick.classList.add("paymentTypeTickDisable");
            }
        }

        this.props.payment.paymentTypes.map((payment, i) => {
            if (payment.id !== targetId) {
                let unActiveTick = document.getElementById("tick_" + payment.id);

                if (unActiveTick !== null) {
                    unActiveTick.classList.add("paymentTypeTickDisable");
                }
            }
        });
    }

    changeAppleGooglePayAvailable = (isAvailable) => {
        const isAppliedGiftCards = this.props.giftCards.giftCards ? this.props.giftCards.giftCards.appliedGiftCards && this.props.giftCards.giftCards.appliedGiftCards.length > 0 : false;
        const totalWithGiftCardIsZero = this.props.giftCards.giftCards ? this.props.giftCards.giftCards.total === 0 : false; 
        if (isAvailable && (!isAppliedGiftCards && !totalWithGiftCardIsZero)) {
            this.setState({
                ...this.state,
                isAppleGooglePayAvailable: isAvailable,
                selectedPaymentId: 3
            })
        } else {
            this.setState({
                ...this.state,
                isAppleGooglePayAvailable: isAvailable
            })
        }
        this.props.changeAppleGooglePayAvailability(isAvailable);
    }

    selectPayment(paymentTypeId) {

        this.props.payment.paymentTypes.map((payment, i) => {
            if (paymentTypeId == payment.id) {
                this.props.selectPaymentType(payment);
                if (payment.value == 'Cash') {
                    this.clearPaymentCard();
                }
            }
        });
    }

    applyGiftCardInformation(appliedGiftCards, currentGiftCard) {
        this.props.applyGiftCard(appliedGiftCards, currentGiftCard, () => {
            this.setState ({
                ...this.state,
                currentGiftCard: {
                    ...this.state.currentGiftCard,
                    cardId: ''
                }
            });
        })
    }

    removeGiftCard(cardToRemoveIndex, appliedGiftCards) {

        let copyOfAppliedGiftCards = appliedGiftCards;

        copyOfAppliedGiftCards.map((card, index) => {
            if(cardToRemoveIndex === index) {
                copyOfAppliedGiftCards.splice(index, 1)
                this.props.applyGiftCard(copyOfAppliedGiftCards, null)
            }
        })
    }


    clearPaymentCard() {
        this.props.clearPaymentCard();
        this.state.activeClass = false;
    }

    renderMenuScreenContent() {
        const { serviceNote } = styles;
        const { menuItemsBackground, menuBackground, primaryFontColor } = this.props.customerThemes.selectedTheme;
        const isArabic = this.props.language === ARABIC;
        let currentMinimumOrderAmount = this.props.shoppingCart.appliedPromotions.length ? 1 : this.props.selectedRestaurant.minimumOrderAmount;
        // const isGiftCardTotalBiggerThanZero = this.props.giftCards.giftCards ? this.props.giftCards.giftCards.appliedGiftCards.length > 0 ? this.props.giftCards.giftCards.total > 0 : true : true;
        const isAppliedGiftCards = this.props.giftCards.giftCards ? this.props.giftCards.giftCards.appliedGiftCards && this.props.giftCards.giftCards.appliedGiftCards.length > 0 : false;
        const shoppingCartTotalWithGiftCard = this.props.giftCards.giftCards ? this.props.giftCards.giftCards.total : null;
        const isTotalWithGiftCardsBiggerThanOne = isAppliedGiftCards ? (shoppingCartTotalWithGiftCard > 1) ? true : false : true;
        const isTotalWithGiftCardsBiggerThanZeroAndLessThanOne = isAppliedGiftCards && ((shoppingCartTotalWithGiftCard < 1) && (shoppingCartTotalWithGiftCard > 0)) ? true : false;

        return (
            <div className="fixedContainer" style={isTablet ? { backgroundColor: menuBackground, padding: 12 } : { backgroundColor: menuBackground }}>
                <Row style={{ margin: 0, paddingTop: 20 }}>

                    {/* Render Payment methods + stripeForm (including SC). At a later stage here might come a check if brand is with stripe or authipay */}
                    <Col xs={12} sm={12} md={8} style={{ backgroundColor: menuBackground }}>
                        <Row style={{ padding: isArabic ? '0 0 15px 12px' : '0 12px 15px 0px', margin: '0 15px' }}>
                            {this.renderCheckoutPaymentInformation()}
                            {
                                (this.props.paymentProvider.providerType && this.props.shoppingCart.total >= currentMinimumOrderAmount && isTotalWithGiftCardsBiggerThanOne) && 
                                <PaymentAdapter
                                    history={this.props.history}
                                    selectCard={this.selectCard}
                                    selectedPaymentId={Number(this.state.selectedPaymentId)}
                                    changeAppleGooglePayAvailable={this.changeAppleGooglePayAvailable}
                                    isAppleGooglePayAvailable={this.state.isAppleGooglePayAvailable}
                                    styles={styles}
                                />
                            }
                            {
                                isTotalWithGiftCardsBiggerThanZeroAndLessThanOne && (this.state.selectedPaymentId == 1) ?
                                <Col xs={12} md={12}> 
                                    <p style={{ color: primaryFontColor, paddingLeft: '10%' }}>{i18n.t(`screens:checkoutScreen.totalMustBeGreaterOrEqualTo1`)}</p>
                                </Col> : null
                            }
                        </Row>

                        {this.renderCheckoutInformation()}
                    </Col>
                    <Col xs={12} sm={12} md={this.props.isPWA ? 12 : 4} style={this.props.isPWA ? {} : { paddingLeft: 0, paddingRight: 0, backgroundColor: menuItemsBackground }}>
                        <ShoppingCart
                            orderButton={i18n.t('screens:shoppingCart.placeOrder')}
                            isCardValid={this.props.payment.isCardValid}
                            paymentId={this.state.selectedPaymentId}
                            history={this.props.history}
                            isAppleGooglePaySelected={Number(this.state.selectedPaymentId) === 3}
                            selectedPaymentId={this.state.selectedPaymentId}
                            isCheckoutScreen={true}
                        />
                    </Col>
                </Row>
            </div>
        );
    }

    selectCard(card) {
        let cardInfo = null;
        const isMoneris = this.props.paymentProvider.providerType ? this.props.paymentProvider.providerType.id === 5 ? true : false : false;
        // console.log('selectCard card ', card, ' props. ', this.props.payment.selectedPaymentCard);
        if (!card) {
            cardInfo = this.props.payment.selectedPaymentCard;
        } else {
            cardInfo = card;
            // console.log('selectCard cardInfro ELSE ', cardInfo);
        }
        // console.log('selectCard cardInfo ', cardInfo, ' cardInfo.brand ', cardInfo.brand);

        if(cardInfo.brand && isMoneris && (!cardInfo.street || !cardInfo.streetNumber || !cardInfo.zipCode)) {
            console.log('Inside Selected Card Toggle Modal')

            this.setState({
                isSavedCardModalOpen: !this.state.isSavedCardModalOpen,
                selectedCardInfo: cardInfo
            })
        } else if (cardInfo.brand && isMoneris) {
            const selectedCard = {
                'brand': cardInfo.brand,
                'paymentCardId': cardInfo.paymentCardId,
                'lastDigits': cardInfo.lastDigits,
                'street': cardInfo.street,
                'streetNumber': cardInfo.streetNumber,
                'zipCode': cardInfo.zipCode
            }

            this.setState({
                activeClass: !this.state.activeClass,
                selectedPaymentCard: selectedCard
            }, (!this.state.activeClass) ? this.props.selectCustomerPaymentCard(selectedCard) : this.clearPaymentCard());
        } else if(cardInfo.brand) {
            const selectedCard = {
                'brand': cardInfo.brand,
                'paymentCardId': cardInfo.paymentCardId,
                'lastDigits': cardInfo.lastDigits
            }

            this.setState({
                activeClass: !this.state.activeClass,
                selectedPaymentCard: selectedCard
            }, (!this.state.activeClass) ? this.props.selectCustomerPaymentCard(selectedCard) : this.clearPaymentCard());
        }
    }

    toggleSavedCardsModal() {
        if(this.state.isSavedCardModalOpen) {
            this.setState({ 
                ...this.state, 
                isSavedCardModalOpen: false,
                selectedCardInfo: null 
            });
        } else {
            this.setState({ 
                ...this.state, 
                isSavedCardModalOpen: true });
        }
    }

    deleteSavedCreditCard() {
        
        if(this.state.selectedCardInfo && this.state.selectedCardInfo.paymentCardId) {
            this.props.deleteCustomerCard(this.state.selectedCardInfo.paymentCardId, () => {
                this.setState({
                    isSavedCardModalOpen: false,
                    selectedCardInfo: null
                })
            });
        }
    }

    renderSavedCardModalBody() {
        const { primaryColor, menuItemsBackground } = this.props.customerThemes.selectedTheme;
        const { savedGiftCardContainer } = styles;
        const mobileStars = ' **** **** **** ';

        return (
            <Row>
                <Col xs={12} style={{display: 'flex', justifyContent: 'center', flexDirection: 'column', textAlign: 'center'}}>
                <div style={{...savedGiftCardContainer, backgroundColor: menuItemsBackground}}>
                    <span style={{textAlign: 'center', color: primaryColor, fontWeight: 'bold'}}>
                        {mobileStars + this.state.selectedCardInfo.lastDigits + ' '}
                    </span>
                </div>
                <div style={{maxWidth: '400px', margin: '0px auto 20px'}}>{i18n.t('screens:checkoutScreen.deleteSavedCardInfo')}</div>
                </Col>
            </Row>
        )
    }


    renderCheckoutPaymentInformation() {
        const isArabic = this.props.language === ARABIC;
        return (
            <CheckoutPaymentInformation
                // Store props
                customerThemes={this.props.customerThemes}
                customer={this.props.customer}
                brand={this.props.brand}
                payment={this.props.payment}
                shoppingCart={this.props.shoppingCart}
                // State props
                changeState={this.changeState}
                changePaymentStateMobile={this.changePaymentStateMobile}
                selectedPaymentId={this.state.selectedPaymentId}
                selectCard={this.selectCard}
                activeClass={this.state.activeClass}
                selectedPaymentCard={this.state.selectedPaymentCard}
                selectedRestaurant={this.props.selectedRestaurant}
                paymentProvider={this.props.paymentProvider}
                isAppleGooglePayAvailable={this.state.isAppleGooglePayAvailable}
                styles={styles}
                isPWA={this.props.pwaAppRunning}
                isArabic={isArabic}
                giftCards={this.props.giftCards}
                toggleDeleteCardDialog={this.toggleDeleteCardDialog}
            />
            // </div>
        );
    }

    renderCheckoutInformation() {
        const isArabic = this.props.language === ARABIC;
        return (
            <CheckoutInformation
                // Store props
                history={this.props.history}
                customerThemes={this.props.customerThemes}
                customer={this.props.customer}
                orderTypes={this.props.orderTypes}
                menuPreviewMode={this.props.menuPreviewMode}
                brand={this.props.brand}
                selectedRestaurant={this.props.selectedRestaurant}
                estimateOrderTime={this.props.estimateOrderTime}
                // Action props
                clearWizardData={this.props.clearWizardData}
                clearState={this.props.clearState}
                clearTemporaryOrderTimeData={this.props.clearTemporaryOrderTimeData}
                openChangeOrderTimeScreen={this.props.openChangeOrderTimeScreen}
                // State props
                changeState={this.changeState}
                changeNotes={this.changeNotes.bind(this)}
                generalInstructions={this.state.generalInstructions}
                paymentType={this.state.paymentType}
                activeClass={this.state.activeClass}
                isArabic={isArabic}
                currentGiftCard={this.state.currentGiftCard}
                giftCards={this.props.giftCards}
                giftCardsErrorMessage={this.props.giftCards.errorMessage}
                removeGiftCard={this.removeGiftCard}
                applyGiftCardInformation={this.applyGiftCardInformation}
                styles={styles} 
            />
        );
    }

    renderTransparentBackgroundLoaderContainer() {
        const { loadingIndicator } = styles;
        const { primaryColor } = this.props.customerThemes.selectedTheme;
        const { loadingContainerTransparent } = this.props.customerThemes.constantStyles;

        if (this.props.shoppingCart.promoCallsCount !== 0) {
            return (
                <div style={loadingContainerTransparent}>
                    <div style={loadingIndicator} className='text-center loadingIndicator'>
                        <GridLoader color={primaryColor} size={20} />
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }

    toggleSendingOrderModal() {
        // console.log('toggleSendingOrderModal');
    }

    applyTheme(prevProps) {
        if (prevProps && this.props.customerThemes.selectedTheme.colorsCss !== prevProps.customerThemes.selectedTheme.colorsCss && this.props.customerThemes.selectedTheme.colorsCss) {
            updateCSSVariables(this.props.customerThemes.selectedTheme.colorsCss);
        } else {
            updateCSSVariables(this.props.customerThemes.selectedTheme.colorsCss);
        }

        let customizedStyles = JSON.parse(JSON.stringify(styles));
        const { primaryColor, secondaryColor, primaryFontColor, fontWeight, textDecoration, chefNoteBackground, mainTextColor, menuItemsBackground, fontFamilyType, fontBold, fontItalic, uppercase, menuBackground } = this.props.customerThemes.selectedTheme;

        customizedStyles.updateInfoStyle.color = primaryColor;
        customizedStyles.updateInfoStyle.fontWeight = fontWeight;
        customizedStyles.updateInfoStyle.textDecoration = textDecoration;
        customizedStyles.checkoutCustomerContainer.fontWeight = fontWeight;
        customizedStyles.sectionTitle.color = secondaryColor;
        customizedStyles.instructionsInput.backgroundColor = chefNoteBackground;
        customizedStyles.charactersInfo.color = mainTextColor;
        customizedStyles.availableCard.color = primaryColor;
        customizedStyles.cardBrand.color = primaryFontColor;
        customizedStyles.cardNumber.color = primaryFontColor;
        customizedStyles.listGroupActiveStyle.background = menuItemsBackground;
        customizedStyles.listGroupActiveStyle.border = `1px solid ${primaryColor}`;
        customizedStyles.sectionTitle.fontFamily = fontFamilyType;
        customizedStyles.sectionTitle.fontWeight = fontBold === 'bold' ? fontBold : 300;
        customizedStyles.sectionTitle.fontStyle = fontItalic;
        customizedStyles.sectionTitle.textTransform = uppercase;
        customizedStyles.dropdownPayments.backgroundColor = menuBackground;
        customizedStyles.dropdownPayments.color = primaryFontColor;
        styles = customizedStyles;
        return styles;
    }

    render() {
        const { customer } = this.props;
        const userFirstName = getLoggedInUserFirstName(customer.name);
        const isLoggedInPromotionPartner = this.props.promotionPartners.isUserLoggedInPartner;
        const textData = {
            informationMessage: i18n.t('screens:checkoutScreen.informationMessage')
        };
        const deleteCardTextData = {
            informationMessage: i18n.t('screens:profileScreen.deleteCardConfirmation'),
            confirmationMessage: null
        };
 
        return (
            <Fragment>
                <MenuLoaderContainer {...this.props} />
                <ApplicationStep
                    hideBackButton={false}
                    transparentHeader={false}
                    goBack={isLoggedInPromotionPartner ? this.toggleConfirmationModal.bind(this) : this.goBack.bind(this)}
                    text={`${i18n.t('screens:checkoutScreen.checkoutHeader')} ${userFirstName}`}
                    content={this.renderMenuScreenContent()}
                    isLoadedFromCheckout={true}
                />
                <SendingOrderModal isOpen={this.props.sendOrderModal.sendOrderModalOpened}
                    orderStatusMessage={this.props.sendOrderModal.orderStatusMessage}
                    customerInfoMessage={this.props.sendOrderModal.customerInfoMessage}
                    orderSucceed={this.props.sendOrderModal.orderSucceed}
                    onToggle={this.toggleSendingOrderModal}
                    biggerInfoMessage={this.props.sendOrderModal.biggerInfoMessage}
                />
                {this.renderTransparentBackgroundLoaderContainer()}
                {
                    this.state.openConfirmationModal &&
                    <ConfirmationModal
                        isOpen={this.state.openConfirmationModal}
                        onToggle={this.toggleConfirmationModal.bind(this)}
                        onConfirm={this.goBack.bind(this)}
                        message={textData}
                        customerThemes={this.props.customerThemes}
                    />
                }
                {
                    this.state.isSavedCardModalOpen &&
                    <SavedCardsModal
                        isOpen={this.state.isSavedCardModalOpen}
                        onToggle={this.toggleSavedCardsModal}
                        onConfirm={this.deleteSavedCreditCard}
                        customerThemes={this.props.customerThemes}
                        body={this.renderSavedCardModalBody}
                    />
                }
                {
                    this.state.openDeleteCardDialog &&
                    <ConfirmationModal
                    isOpen={this.state.openDeleteCardDialog}
                    onToggle={this.toggleDeleteCardDialog}
                    onConfirm={this.confirmDeleteCard}
                    message={deleteCardTextData}
                    customerThemes={this.props.customerThemes}
                    />
                }
            </Fragment>
        );
    }
}

const mapStateToProps = state => {

    return {
        customer: state.customer,
        sendOrderModal: state.sendOrderModal,
        isStartOrderScreenOpened: state.startOrder.startOrderScreenOpened,
        shoppingCartProducts: state.shoppingCart.orderProducts,
        shoppingCart: state.shoppingCart,
        payment: state.payment,
        brand: state.brand,
        selectedRestaurant: state.selectedRestaurant,
        selectedMenuId: state.restaurantMenus.selectedMenuId,
        selectedProduct: state.selectedProduct,
        orderTypes: state.orderTypes,
        estimateOrderTime: state.estimateOrderTime,
        temporaryOrderTime: state.temporaryOrderTime,
        changeOrderTimeScreenOpened: state.temporaryOrderTime.changeOrderTimeScreenOpened,
        menuPreviewMode: state.menuPreviewMode,
        customerThemes: state.customerThemes,
        pwaAppRunning: state.pwaAppRunning,
        serviceNote: state.menuDescription.serviceNote,
        paymentProvider: state.paymentProvider,
        restaurantProducts: state.restaurantProducts,
        restaurantCategories: state.restaurantCategories,
        storeLocalStorage: state.storeLocalStorage,
        promotionPartners: state.promotionPartners,
        brandId: state.brand.id,
        language: state.storeLocalStorage.language,
        giftCards: state.giftCards,
        loading: state.loading
    };
};

export default connect(mapStateToProps, {
    loadPaymentTypes,
    selectPaymentType,
    getCustomerPaymentCards,
    selectCustomerPaymentCard,
    editProduct,
    clearPaymentCard,
    saveGeneralInstructions,
    clearWizardData,
    getSelectedProductForEdit,
    closeStartOrderScreen,
    openChangeOrderTimeScreen,
    clearTemporaryOrderTimeData,
    saveNewOrderTime,
    clearState,
    getSelectedProduct,
    stopLoader,
    processingPayment,
    getOldestActiveLoyalty,
    changeAppleGooglePayAvailability,
    getRestaurantPauseStatus,
    voidPurchase,
    resetOldDiscountFlag,
    cancelComoPayment,
    applyGiftCard,
    clearGiftCardsErrorMessage,
    deleteCustomerCard
})(CheckoutScreenPwa);

let styles = {
    checkoutTitleContainer: {
        marginTop: 15,
        marginBottom: 0
    },
    cardBrand: {
        paddingRight: 10
    },
    cardNumber: {
        paddingRight: 10
    },
    checkoutCustomerContainer: { fontSize: 22, marginBottom: 0, textAlign: 'center', paddingTop: 4 },
    sectionContainerStyle: {
        paddingTop: 10,
        paddingLeft: 0,
        marginBottom: 20,
        paddingRight: 0
    },
    sectionTop: { marginTop: 15 },
    sectionBorderTop: { borderTop: '1px solid rgba(167, 167, 167, 0.5)' },
    sectionBorderBottom: { borderBottom: '1px solid rgba(167, 167, 167, 0.5)' },
    sectionStyle: {
        paddingLeft: 0,
        marginRight: 3
    },
    iconStyle: {
        padding: 0,
        marginRight: -6
    },
    profileIconStyle: { marginLeft: 3 },
    charactersInfo: { float: 'right', fontSize: 12, color: '#a7a7a7' },
    locationIconStyle: {
    },
    sectionTitle: {
        color: '#a7a7a7', fontSize: 18, fontFamily: 'Roboto',
        fontWeight: 300,
        marginBottom: 4
    },
    separatorStyle: { color: 'rgba(167, 167, 167, 0.5)', margin: '0px 6px 0px 6px' },
    updateInfoStyle: {
        color: '#62b400',
        cursor: 'pointer'
    },
    disabledLink: {
        color: 'grey',
        cursor: 'pointer',
        pointerEvents: 'none'
    },
    radioBtnOne: {
        fontSize: 16,
        marginRight: 20
    },
    paymentTypeButtons: {
        display: 'flex',
        marginTop: 10,
        paddingLeft: 0
    },
    checkoutStripeContainer: { float: 'right', paddingRight: 0, marginLeft: 4, marginTop: -5 },
    shoppingCartContainer: {
        margin: 'auto',
        height: 580,
        backgroundColor: '#fff',
        boxShadow: '1px 0px 24px 2px rgba(0,0,0,0.15)',
        padding: 0,
        float: 'right'
    },
    listGroupStyle: {
        cursor: 'pointer',
        background: '#e4e4e461',
        borderTop: 'none',
        borderRadius: 0,
        paddingRight: 15,
        paddingLeft: 15,
        marginBottom: 10
    },
    listGroupActiveStyle: {
        cursor: 'pointer',
        background: '#fff',
        border: '1px solid #63b400',
        borderRadius: 0,
        paddingRight: 15,
        paddingLeft: 15,
        marginBottom: 10
    },
    expiredCard: { color: 'grey', float: 'right' },
    availableCard: { color: '#62b400', float: 'right', cursor: 'pointer' },
    instructionsInput: {
        width: '100%',
        border: '1px solid #cfd5da',
        borderRadius: 0,
        height: 38,
        marginTop: 5,
        paddingLeft: 12,
        fontSize: 14,
        zIndex: '1 !important'
    },
    backButtonStyle: {
        marginLeft: -5,
        marginRight: 25
    },
    orderTypeBtnsContainer: {
        marginTop: 25,
        marginBottom: -30
    },
    checkoutContainer: {
        marginLeft: -3,
        marginRight: 12
    },
    alignLeft: {
    },
    checkoutContainerCol: {},
    checkIconStyle: { marginTop: '30%', float: 'right', marginRight: 5 },
    infoRowStyle: {
        marginTop: 7,
        marginLeft: 0,
        marginRight: 0,
        padding: 0,
        zIndex: 2
    },
    serviceNote: {
        fontSize: 14,
        color: 'rgb(110, 118, 118)',
        padding: '0 33px 0 27px'
    },
    dropdownPayments: {
        borderRadius: 0,
        borderColor: 'rgba(167, 167, 167, 0.5)',
        fontWeight: 300
    },
    dropDownOptions: {
        fontWeight: 300
    },
    cardsInfoMessage: {
        fontSize: 13,
        color: '#fff',
        marginBottom: 0,
        marginTop: 4
    },
    savedGiftCardContainer: {
        width: '300px',
        height: '140px',
        display: 'flex',
        borderRadius: '15px',
        boxShadow: '1px 0px 24px 2px rgba(0,0,0,0.15)',
        margin: '10px auto',
        justifyContent: 'center',
        alignItems: 'center'
    }
};